<template>
    <div id="container-information-pdf">
      <iframe
        class="embed-responsive-item"
        type="application/pdf"
        :src="link + indicators[index].pdf"
        allowfullscreen
      />
    </div>
  </template>

  <script>
  import { mapState } from 'vuex'
  import queries from '../../services/directQueries.js'

  export default {
    name: 'IndicatorsInformationPdf',

    data () {
      return {
        link: queries.pdfs
      }
    },

    props: {
      indicators: Object
    },

    computed: {
      ...mapState(['index'])
    }
  }

  </script>

  <style scoped>

  #container-information-pdf {
    margin-left: 2rem;
    border: 1px solid gray;
    border-radius: .5em;
    width: 68%;
  }

  #container-information-pdf iframe {
    border-radius: .5em;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 769px) {
    #container-information-pdf {
      height: 50vh;
      margin-left: 0;
    }
  }

  </style>